import React, { useState, useEffect } from "react";
import "./css/thumbnail.css";
import styled from "styled-components";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

const Contain = styled.div`
  position: relative;
  text-align: center;
  color: white;
`;

const Label = styled.div`
  margin-bottom: auto;
  text-align: right;
  line-height: 22px;
  margin-block: 22px;
`;

function ThumbNail({ sender, reciever, message, printRef }) {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);
  const [image, setImage] = useState("postal-1");

  useEffect(() => {
    setNav1(slider1);
    setNav2(slider2);
  });

  const buildPreview = () => {
    switch (image) {
      case "postal-1":
        return (
          <div
            id="postal-1"
            className="col-12 col-md-6"
            style={{ marginTop: "4rem" }}
          >
            <Label top="10%" right="30%">
              <h1 style={{ lineHeight: "22px" }}>
                {reciever ? reciever : "دوست"} عزیز
              </h1>
            </Label>
            <Label
              top="4rem"
              right="30%"
              style={{ maxWidth: "100%", textAlign: "right" }}
            >
              <h6 style={{ lineHeight: "22px" }}>{message}</h6>
            </Label>
            <Label top="100%" right="30%">
              <h4 style={{ lineHeight: "22px" }}>از طرف {sender}</h4>
            </Label>
          </div>
        );

      case "postal-2":
        return (
          <Contain
            id="postal-2"
            className="col-12 col-md-6"
            style={{ marginTop: "4rem", paddingTop: "8rem" }}
          >
            <Label top="35%" right="30%">
              <h1 style={{ lineHeight: "22px" }}>
                {reciever ? reciever : "دوست"} عزیز
              </h1>
            </Label>
            <Label
              top="45%"
              right="30%"
              style={{ maxWidth: "100%", textAlign: "right" }}
            >
              <h6 style={{ lineHeight: "22px" }}>{message}</h6>
            </Label>
            <Label top="60%" right="60%">
              <h4 style={{ lineHeight: "22px" }}>از طرف {sender}</h4>
            </Label>
          </Contain>
        );
      case "postal-3":
        return (
          <Contain
            id="postal-3"
            className="col-12 col-md-6"
            style={{ marginTop: "4rem", paddingTop: "5rem" }}
          >
            <Label top="25%" right="30%">
              <h1 style={{ lineHeight: "22px" }}>
                {reciever ? reciever : "دوست"} عزیز
              </h1>
            </Label>
            <Label
              top="35%"
              right="30%"
              style={{ maxWidth: "100%", textAlign: "right" }}
            >
              <h6 style={{ lineHeight: "22px" }}>{message}</h6>
            </Label>
            <Label top="55%" right="55%">
              <h4 style={{ lineHeight: "22px" }}>از طرف {sender}</h4>
            </Label>
          </Contain>
        );
      case "postal-4":
        return (
          <Contain
            id="postal-4"
            className="col-12 col-md-6"
            style={{ marginTop: "4rem" }}
          >
            <Label top="5%" right="44%">
              <h1 style={{ lineHeight: "22px" }}>
                {reciever ? reciever : "دوست"} عزیز
              </h1>
            </Label>
            <Label
              top="15%"
              right="30%"
              style={{ maxWidth: "100%", textAlign: "right" }}
            >
              <h6 style={{ lineHeight: "22px" }}>{message}</h6>
            </Label>
            <Label top="100%" right="30%">
              <h4 style={{ lineHeight: "22px" }}>از طرف {sender}</h4>
            </Label>
          </Contain>
        );

      case "postal-6":
        return (
          <Contain
            id="postal-6"
            className="col-12 col-md-6"
            style={{ marginTop: "4rem", paddingTop: "5rem" }}
          >
            <Label top="26%" right="30%">
              <h1 style={{ lineHeight: "22px" }}>
                {reciever ? reciever : "دوست"} عزیز
              </h1>
            </Label>
            <Label
              top="35%"
              right="30%"
              style={{ maxWidth: "100%", textAlign: "right" }}
            >
              <h6 style={{ lineHeight: "22px" }}>{message}</h6>
            </Label>
            <Label top="47%" right="30%">
              <h4 style={{ lineHeight: "22px" }}>از طرف {sender}</h4>
            </Label>
          </Contain>
        );
        case "postal-7":
          return (
            <Contain
              id="postal-7"
              className="col-12 col-md-6"
              style={{ marginTop: "4rem", paddingTop: "5rem" }}
            >
              <Label top="26%" right="30%">
                <h1 style={{ lineHeight: "22px" }}>
                  {reciever ? reciever : "دوست"} عزیز
                </h1>
              </Label>
              <Label
                top="35%"
                right="30%"
                style={{ maxWidth: "100%", textAlign: "right" }}
              >
                <h6 style={{ lineHeight: "22px" }}>{message}</h6>
              </Label>
              <Label top="47%" right="30%" style={{float:'left'}}>
                <h4 style={{ lineHeight: "22px" }}>از طرف {sender}</h4>
              </Label>
            </Contain>
          );

      default:
        return null;
    }
  };

  const settingsMain = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav",
  };

  //   const settingsThumbs = {
  //     slidesToShow: 3,
  //     slidesToScroll: 1,
  //     asNavFor: ".slider-for",
  //     dots: true,
  //     centerMode: true,
  //     swipeToSlide: true,
  //     focusOnSelect: true,
  //     centerPadding: "10px",
  //   };
  const settingsThumbs = {
    arrows: true,
    dots: true,
    infinite: true,
    asNavFor: ".slider-for",
    centerMode: true,
    speed: 1000,
    autoplay: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const slidesData = [
    {
      id: 1,
      title: "postal-1",
      label: "",
    },
    {
      id: 2,
      title: "postal-2",
      label: "",
    },
    {
      id: 3,
      title: "postal-3",
      label: "",
    },
    {
      id: 4,
      title: "postal-4",
      label: "",
    },
  
    {
      id: 6,
      title: "postal-6",
      label: "",
    },
    {
      id: 7,
      title: "postal-7",
      label: "",
    },
  ];

  const handleClickImageSlide = (title) => {
    setImage(title);
    console.log("title", title);
  };

  return (
    <div className="slider-wrapper">
      <div className="thumbnail-slider-wrap">
        <Slider
          {...settingsThumbs}
          asNavFor={nav1}
          ref={(slider) => setSlider2(slider)}
        >
          {slidesData.map((slide) => (
            <div
              className="slick-slide"
              key={slide.id}
              onClick={() => handleClickImageSlide(slide.title)}
            >
              <img
                className="slick-slide-image"
                src={`./media/landings/postCard/${slide.title}.jpg`}
              />
            </div>
          ))}
        </Slider>
      </div>

      {/** بخش نمایش عکس **/}
      <div ref={printRef}>{buildPreview()}</div>

      {/*** یا این دایو بالا رو اجرا کن یا این پایینیه. پایینیه واسه خود اسلایدره ست ***/}

      {/* <Slider
                {...settingsMain}
                asNavFor={nav2}
                ref={slider => (setSlider1(slider))}
            > */}

      {
        // slidesData.map((slide) =>
        //     <div className="slick-slide" key={slide.id}>
        //         {/* <h2 className="slick-slide-title">{slide.title}</h2> */}
        //         <img className="slick-slide-image" src={`./media/landings/postCard/${slide.title}.jpg`} />
        //     </div>
        // )
      }

      {/* </Slider> */}
    </div>
  );
}

export default ThumbNail;
